module.exports = __webpack_public_path__ + "static/dropdown-menu-75542147f561322fcd915d66c228b7cd.svg";